import type { ReactElement } from 'react';
import cx from 'clsx';
import { useField } from '@ff-it/form';
import { Box, Switch } from '@ff-it/ui';
import { ConfigProps } from './types';
import { ActivityType } from 'types';
import { rtbProductConfig } from 'modules/rtb';
import type { ProductFormConfig } from '../types';
import { oohProductConfig } from 'modules/ooh';

const CONFIG_FORM_MAP: Partial<Record<ActivityType, ProductFormConfig>> = {
  RTB: rtbProductConfig,
  WEB: rtbProductConfig,
  OOH: oohProductConfig,
};

export function Config(props: ConfigProps): ReactElement | null {
  const {
    input: { value },
  } = useField('configuration', { allowNull: true, subscription: { value: true } });

  const Component = CONFIG_FORM_MAP[props.type]?.Component;

  return Component && value ? (
    <fieldset className="mb-2">
      <legend>Configuration</legend>
      <Component />
    </fieldset>
  ) : null;
}

export function ConfigToggle({ className, ...props }: ConfigProps & { className?: string }): ReactElement | null {
  const {
    input: { value, onChange },
  } = useField('configuration', { allowNull: true, subscription: { value: true } });
  const config = CONFIG_FORM_MAP[props.type];
  if (!config) {
    return null;
  }

  const enabled = Boolean(value);
  return (
    <div className={cx('form-group', className)}>
      <label htmlFor="product-toggle">Product details </label>
      <Box>
        <Switch
          checked={enabled}
          onChange={() => onChange(enabled ? null : config.initialValues)}
          id="product-toggle"
        />
        <small className="form-text text-muted">product with type configuration</small>
      </Box>
    </div>
  );
}
